// extracted by mini-css-extract-plugin
export var readonly = "_hl-1";
export var star = "_hl-0";